import {
    apiRequest,
    levelTunjanganKhususCreate, 
    levelTunjanganKhususUpdate
} from "../../../../../services/adapters/master/levelTunjanganKhususService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", levelTunjanganKhususCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", levelTunjanganKhususUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository